<template>
  <FormItem :label="(label || 'label') + ':'" class="search-formItem">
    <Select class="search-input" v-model="dataValue" :placeholder="placeholder || '全部'" size="small"
            @on-select="changeValue">
      <Option v-for="(item,index) in list" :key="item.value" :value="item.value">{{ item.label }}</Option>
    </Select>
  </FormItem>
</template>

<script>
export default {
  name: 'search-form-item-select',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    label: String,
    placeholder: String,
    value: {
      type: String | Number,
      default: ''
    },
    list: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      dataValue: 0
    }
  },
  created () {
    this.dataValue = this.value
    console.log(this.dataValue)
  },
  methods: {
    changeValue (e) {
      this.dataValue = e.value
      this.$emit('on-change', e.value);
    }
  },
  watch: {
    value (val) {
      this.dataValue = val
    }
  }
}
</script>

<style lang="less">
.search-formItem {
  width: 32%;
  margin-top: 10px;
  margin-bottom: 0;
}
</style>
